import React from "react";
import { motion } from "framer-motion";

const SocialIcon = ({ href, label, children, accent = "green" }) => {
  const colors = {
    green: {
      border: "rgba(0,255,153,0.22)",
      glow: "0 0 18px rgba(0,255,153,0.35), inset 0 0 12px rgba(0,255,153,0.08)",
      text: "text-green-400",
      hover: "group-hover:text-green-300",
    },
    cyan: {
      border: "rgba(6,182,212,0.22)",
      glow: "0 0 18px rgba(6,182,212,0.35), inset 0 0 12px rgba(6,182,212,0.08)",
      text: "text-cyan-400",
      hover: "group-hover:text-cyan-300",
    },
  };
  const c = colors[accent] ?? colors.green;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      whileHover={{ scale: 1.12, y: -3 }}
      whileTap={{ scale: 0.95 }}
      className={`relative group flex flex-col items-center justify-center gap-1.5 w-16 h-16 rounded-xl transition-colors duration-300 ${c.text}`}
      style={{
        background: "rgba(10,22,40,0.75)",
        border: `1px solid ${c.border}`,
      }}
    >
      {/* Glow ring */}
      <span
        className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        style={{ boxShadow: c.glow }}
      />
      <span
        className={`relative z-10 ${c.hover} transition-colors duration-300`}
      >
        {children}
      </span>
      <span className="relative z-10 text-[9px] tracking-widest font-mono opacity-50 group-hover:opacity-80 transition-opacity duration-300 uppercase">
        {label}
      </span>
    </motion.a>
  );
};

export default SocialIcon;
